import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { currentEnvName } from "./helpers/utils_env";

// updates document title based on environment (ENV)
const getDocTitle = () => {
	const envName = currentEnvName;
	if (envName === "prod" || envName === "production") {
		return (document.title = "Internal");
	} else {
		return (document.title = "Internal ~ 👉 TEST 👈 ");
	}
};

getDocTitle();

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
